var map = {
	"./about-us.svg": 761,
	"./betting-icon.svg": 762,
	"./bonus.svg": 763,
	"./coin.png": 764,
	"./contact-us.svg": 765,
	"./download-app.svg": 766,
	"./edit-btn.svg": 767,
	"./feedback.svg": 768,
	"./global.svg": 769,
	"./info-centre.svg": 770,
	"./instant-rebate.svg": 771,
	"./mall-icon.svg": 772,
	"./message.svg": 773,
	"./redemption-icon.svg": 774,
	"./referral.svg": 775,
	"./resp-gaming.svg": 776,
	"./security.svg": 777,
	"./transaction-icon.svg": 778,
	"./vip-icon.svg": 779,
	"./wallet-icon.svg": 780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;